import {ChangeEvent} from "react";
import {NextRouter} from "next/router";
import {TranslationsType} from "../../../types/homePageTypes";
import {ParsedUrlQuery} from "node:querystring";

export const handleFilterChange = async (
    {
        target: {
            value: targetValue,
            checked: targetChecked
        }
    }: ChangeEvent<HTMLInputElement>,
    router: NextRouter,
    code: string
) => {
    const {query: routerQueryCore, push: routerPush} = router
    const routerQuery: ParsedUrlQuery = routerQueryCore
    delete routerQuery?.page
    const filterCode = routerQuery?.[`filter_${code}`]
    const existFilterCode = (() => {
        let filterArr = null;
        if (filterCode) filterArr = String(filterCode).split(",")
        if (targetChecked) {
            if (filterArr) {
                return {...routerQuery, [`filter_${code}`]: [...filterArr, targetValue].join(",")}
            }
            return {...routerQuery, [`filter_${code}`]: [targetValue].join(",")}
        } else {
            const filteredItem = filterArr
                ?.filter((elem) => String(elem) !== String(targetValue))
            if (filteredItem && filteredItem?.length > 0) {
                return {...routerQuery, [`filter_${code}`]: filteredItem.join(",")}
            }
            delete routerQuery?.[`filter_${code}`]
            return {...routerQuery}
        }
    })()
    await routerPush({query: {...existFilterCode}}, undefined, {scroll: false})
}

export const optionsHandler = (translationsData: TranslationsType, sortByPrice: string) => {
    const Intl_keys_sortBy: Record<string, string> = {
        asc: "PriceLowHigh",
        desc: "PriceHighLow",
        default: "Default"
    } as const
    return {
        attribute_code: translationsData?.SortBy,
        default_label: translationsData?.[Intl_keys_sortBy[sortByPrice]],
        idKey: Intl_keys_sortBy[sortByPrice],
        field_options: [
            {
                id: 0,
                label: translationsData?.Default,
                key: "default",
                idKey: "sort_by"
            },
            {
                id: 1,
                label: translationsData?.PriceLowHigh,
                key: "asc",
                idKey: "price_low_high"
            },
            {
                id: 2,
                label: translationsData?.PriceHighLow,
                key: "desc",
                idKey: "price_high_low"
            },
        ]
    }
}
